import PlaceOutlined from '@mui/icons-material/PlaceOutlined';
import { IAbsenteeismRateItem } from '../../../interfaces/IAbsenteeismRate';
import { AbsenteeismRateCard } from './AbsenteeismRateCard';

export const RankLocalWithMoreMedicalCertificate = ({ data }: { data: IAbsenteeismRateItem[] }) => (
  <AbsenteeismRateCard
    icon={<PlaceOutlined />}
    title="Taxa de absenteísmo por local"
    subtitle="Colaboradores com atestado sobre o total do local"
    data={data}
  />
);
